import PlacesAutocomplete from 'stimulus-places-autocomplete'
// Connects to data-controller="places"
export default class PlacesController extends PlacesAutocomplete {
  static targets = [
    'address',
    'city',
    'streetNumber',
    'route',
    'postalCode',
    'country',
    'county',
    'state',
    'longitude',
    'latitude',
    'citySearch'
  ]

  placeChanged() {
    super.placeChanged()

    let addressComponents = this.place.address_components;

    let city = addressComponents.find(component => component.types.includes('locality'))?.long_name || '';
    let country = addressComponents.find(component => component.types.includes('country'))?.long_name || '';
    let state = addressComponents.find(component => component.types.includes('administrative_area_level_1'))?.long_name || '';
    let lat = this.place.geometry?.location.lat() || '';
    let lng = this.place.geometry?.location.lng() || '';

    let location = {
      city: city,
      country: country,
      state: state,
      lat: lat,
      lng: lng,
      place: this.addressTarget?.value
    };

    const otherController = this.application.getControllerForElementAndIdentifier(document.getElementById('new-audience-form'), 'audience')
    if (otherController !== null){
      otherController.setLocalLocationFormData(location)
    }
    this.flyToLocation(lat, lng)

    this.addressTarget.dispatchEvent(
      new CustomEvent("location-selected", { bubbles: true })
    )
  }

  addressTargetConnected(e){
    super.connect()
  }

  changeCity(e){
    let input = this.addressTarget, options = {
      types: ['(cities)'],
    };
    let cityPlace = new google.maps.places.Autocomplete(input, options);
    google.maps.event.addListener(cityPlace, 'place_changed', function() {
      let place = cityPlace.getPlace();
      let addressComponents = place.address_components;

      let city = addressComponents.find(component => component.types.includes('locality'))?.long_name || '';
      let country = addressComponents.find(component => component.types.includes('country'))?.long_name || '';
      let state = addressComponents.find(component => component.types.includes('administrative_area_level_1'))?.long_name || '';
      let lat = place.geometry?.location.lat() || '';
      let lng = place.geometry?.location.lng() || '';

      let location = {
        city: city,
        country: country,
        state: state,
        lat: lat,
        lng: lng,
        place: place.formatted_address
      };
      const otherController = this.application.getControllerForElementAndIdentifier(document.getElementById('new-audience-form'), 'audience')
      otherController?.setlocationFormData(location)
      input.value = ""
    }.bind(this))
  }

  flyToLocation(lat, lng) {
    const mapController = this.application.getControllerForElementAndIdentifier(
      document.getElementById('local'),
      'google-map'
    );
    if (mapController) {
      mapController.flyToLocation(lat, lng);
    } else {
      console.error("Google Map controller not found.");
    }
  }

  updateRadius(event) {
    const mapController = this.application.getControllerForElementAndIdentifier(
      document.getElementById('local'),
      'google-map'
    );
    mapController?.updateRadius(event);
  }
}
